
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmptyState',

  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    useV2: {
      type: Boolean,
      default: false
    },
    webpImagePath: {
      type: String,
      default: require('~/assets/images/ui-states/empty.webp')
    },
    pngImagePath: {
      type: String,
      default: require('~/assets/images/ui-states/empty.gif')
    },
    svgImagePath: {
      type: String,
      default: ''
    },
    showBorder: {
      type: Boolean,
      default: false
    },
    imageWidth: {
      type: String,
      default: ''
    },
    altText: {
      type: String,
      default: 'This page has no data'
    },
    contentWidth: {
      type: String,
      default: 'max-w-2xs'
    },
    padding: {
      type: String,
      default: 'px-3.5 py-12 md:px-12 md:py-19'
    }
  }
})
